import React, { useState, useEffect } from 'react';
import './InfoCard.css';

function InfoCard({ tag, headerBio, headerImg, content, more, moreInfo }) {
    const [ moreInfoOpen, setMoreInfoOpen ] = useState(false);
    const handleClick = () => setMoreInfoOpen(!moreInfoOpen);

    const [ mobile, setMobile ] = useState(false);
    const responsiveScreen = () => {
        if (window.innerWidth <= 960) {
            setMobile(true);
        }
    };
    useEffect(() => responsiveScreen(), [mobile]);
    window.addEventListener('resize', responsiveScreen);

    return (
    <>
    {!mobile && <div className="info-card-tag italic-element">
        {tag}
    </div>}
    <div className="info-card">
        <div className="info-card-header">
            {headerBio && <div>
                {headerBio}
            </div>}
            {headerImg && <img src={headerImg} alt="University or company logo" className="info-card-logo" />}
        </div>
        <div className="info-card-content">
            {content}
        </div>
        {more && 
        <div className="more-info-card">
            <div className="more-info-button" onClick={handleClick}>
                <i className="fa fa-angle-down"/>
                <span className="more-info-text">{moreInfo}</span>
            </div>
            {moreInfoOpen && <div className="more-info">
                {more}
            </div>}
        </div>}
    </div>
    </>)
}

export default InfoCard;
